import { markUsFebConsentInteractiveLogin } from '../one-offer-page/consentLoginSignal'

export type InteractiveLoginConsumer = 'remember-me-mint' | 'remember-me-exposure'

let loginGeneration = 0

const lastConsumedGeneration: Record<InteractiveLoginConsumer, number> = {
  'remember-me-mint': 0,
  'remember-me-exposure': 0,
}

export const markInteractiveLogin = (): void => {
  loginGeneration += 1
  markUsFebConsentInteractiveLogin()
}

export const peekInteractiveLoginSignal = (consumer: InteractiveLoginConsumer = 'remember-me-mint'): boolean => {
  return loginGeneration > lastConsumedGeneration[consumer]
}

export const consumeInteractiveLoginSignal = (consumer: InteractiveLoginConsumer = 'remember-me-mint'): boolean => {
  if (loginGeneration > lastConsumedGeneration[consumer]) {
    lastConsumedGeneration[consumer] = loginGeneration
    return true
  }
  return false
}
